var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_3026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.94252 8.70275L15.8045 1.84075C15.926 1.71501 15.9932 1.54661 15.9916 1.37181C15.9901 1.19701 15.92 1.02981 15.7964 0.9062C15.6728 0.782594 15.5056 0.712482 15.3308 0.710963C15.156 0.709444 14.9876 0.77664 14.8619 0.898079L7.99986 7.76008L1.13786 0.898079C1.01212 0.77664 0.843721 0.709444 0.668923 0.710963C0.494126 0.712482 0.326917 0.782594 0.203312 0.9062C0.0797065 1.02981 0.00959389 1.19701 0.00807494 1.37181C0.00655599 1.54661 0.0737523 1.71501 0.195191 1.84075L7.05719 8.70275L0.195191 15.5647C0.0702103 15.6898 0 15.8593 0 16.0361C0 16.2129 0.0702103 16.3824 0.195191 16.5074C0.320209 16.6324 0.489748 16.7026 0.666524 16.7026C0.8433 16.7026 1.01284 16.6324 1.13786 16.5074L7.99986 9.64541L14.8619 16.5074C14.9869 16.6324 15.1564 16.7026 15.3332 16.7026C15.51 16.7026 15.6795 16.6324 15.8045 16.5074C15.9295 16.3824 15.9997 16.2129 15.9997 16.0361C15.9997 15.8593 15.9295 15.6898 15.8045 15.5647L8.94252 8.70275Z",
    fill: "#C2C6CE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_3026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.703125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.d00c219b23e2867238311fe6ea2bd05f.svg";
export { ForwardRef as ReactComponent };